import { CommonModule } from '@angular/common';
import { Component, Input, EventEmitter, Output } from '@angular/core';

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

@Component({
  standalone: true,
  selector: 'colorful-button',
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() label = '';
  @Input() sub = '';
  @Output() buttonClick = new EventEmitter();

  @Input() type: ButtonType = ButtonType.PRIMARY;

  onButtonClick() {
    this.buttonClick.emit();
  }
}
